/**
 * Power-up type definitions for Space Invaders 2030
 */

export enum PowerUpType {
  RAPID_FIRE = 'rapid_fire',
  SHIELD = 'shield',
  MULTI_SHOT = 'multi_shot',
  SLOW_MOTION = 'slow_motion',
  SCORE_MULTIPLIER = 'score_multiplier',
}

export interface PowerUpConfig {
  type: PowerUpType
  name: string
  description: string
  duration: number // Duration in milliseconds
  color: number // Hex color for visual
  spawnChance: number // Probability (0-1) when alien is killed
  icon: string // Text symbol for display
}

export interface ActivePowerUp {
  type: PowerUpType
  startTime: number
  endTime: number
  config: PowerUpConfig
}

export interface PowerUpSprite extends Phaser.GameObjects.Container {
  powerUpType: PowerUpType
  config: PowerUpConfig
}
